import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  topBar: {
    display: 'flex',
    alignItems: 'center',
    height: 48,
    width: '100%',
    justifyContent: 'center'
  },
  skeleton: { width: 150, height: 40, margin: '0 8px' }
}))

export default useStyles
